import { atom } from 'recoil'
import { ISandboxState } from './sandbox.types'

const sandboxAtom = atom<ISandboxState>({
  key: 'sandbox/state',
  default: { levels: [], sets: [], groups: [], tasks: [], draftTask: null, version: null },
})
export default sandboxAtom
